import api from "./api.js";

export default class CategoryApi {
  // ---------- 상품 - 상위 카테고리 ---------- //
  static async createMain(data) {
    return await api.post(`api/merch-main-category`, data);
  }

  static async getListMain(params) {
    return await api.get(`api/merch-main-category`, params);
  }

  static async getByIdMain(categoryId, params) {
    return await api.get(`api/merch-main-category/${categoryId}`, params);
  }

  static async updateMain(data) {
    return await api.patch(`api/merch-main-category/`, data);
  }

  static async deleteMain(categoryId, params) {
    return await api.del(`api/merch-main-category/${categoryId}`, params);
  }

  // ---------- 상품 - 하위 카테고리 ---------- //
  static async createSub(data) {
    return await api.post(`api/merch-sub-category`, data);
  }

  static async getListSub(params) {
    return await api.get(`api/merch-sub-category`, params);
  }

  static async getByIdSub(categoryId, params) {
    return await api.get(`api/merch-sub-category/${categoryId}`, params);
  }

  static async updateSub(data) {
    return await api.patch(`api/merch-sub-category/`, data);
  }

  static async deleteSub(categoryId, params) {
    return await api.del(`api/merch-sub-category/${categoryId}`, params);
  }
}
